import { allPermissionsWithRoutes } from "@/staticData";

const DEFAULT_AUTHENTICATED_ROUTE = "/employee-dashboard";

const priorityRoutes = [
  "/employee-dashboard",
  "/admin-dashboard",
  "/control-panel/module-settings",
];

function normalizeRoutes(routes) {
  return []
    .concat(routes || [])
    .flat(Infinity)
    .filter(Boolean)
    .map((route) => (route.includes(":") ? route.split(":")[0] : route));
}

export function getDefaultAuthenticatedRoute(user) {
  const userPermissions = user?.permission?.map((permission) => permission.name) || [];

  if (!userPermissions.length) {
    return DEFAULT_AUTHENTICATED_ROUTE;
  }

  const accessibleRoutes = userPermissions.flatMap((permissionName) =>
    normalizeRoutes(allPermissionsWithRoutes[permissionName])
  );

  const preferredRoute = priorityRoutes.find((route) =>
    accessibleRoutes.includes(route)
  );

  if (preferredRoute) {
    return preferredRoute;
  }

  return accessibleRoutes[0] || DEFAULT_AUTHENTICATED_ROUTE;
}
